import { FunctionComponent } from 'react'
import { Box, Card, Link, Typography } from '@mui/material'
import {
  FacebookRounded,
  LinkedIn,
  Telegram,
  Twitter,
  WhatsApp,
} from '@mui/icons-material'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

const StyledLink = styled(Link)({
  display: 'flex',
  width: '32px',
  height: '32px',
  border: '1px solid #e1e4e8',
  borderRadius: '32px',
  justifyContent: 'center',
  alignItems: 'center',
  transition: '0.4s',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f0faf8',
  },
  '&:hover svg': {
    color: 'rgb(3, 34, 76)',
  },
})

export const ShareableCard: FunctionComponent = () => {
  const { t } = useTranslation()
  return (
    <Card sx={{ marginTop: '24px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography>{t('share-in-platform')}:</Typography>
        <Box display="flex" gap="16px">
          <StyledLink>
            <FacebookRounded
              sx={{
                color: '#8a94a6',
                fontSize: '20px',
              }}
            />
          </StyledLink>
          <StyledLink>
            <Twitter
              sx={{
                color: '#8a94a6',
                fontSize: '20px',
              }}
            />
          </StyledLink>
          <StyledLink>
            <WhatsApp
              sx={{
                color: '#8a94a6',
                fontSize: '20px',
              }}
            />
          </StyledLink>
          <StyledLink>
            <LinkedIn
              sx={{
                color: '#8a94a6',
                fontSize: '20px',
              }}
            />
          </StyledLink>
          <StyledLink>
            <Telegram
              sx={{
                color: '#8a94a6',
                fontSize: '20px',
              }}
            />
          </StyledLink>
        </Box>
      </Box>
    </Card>
  )
}
